// Vendors
import React from 'react';
// Components
import { ModalContainerComponent } from '@openbank/ziniaweb-ui-components';
import { LandingOptionsModalCloseComponent } from './components/close/landing-options-modal-close.component';
import { LandingOptionsModalFeaturesComponent } from './components/features/landing-options-modal-features.component';
import { LandingOptionsModalFooterComponent } from './components/footer/landing-options-modal-footer.component';
import { LandingOptionsModalTitleComponent } from './components/title/landing-options-modal-title.component';
// Constants
import { LANDING_OPTIONS_MODAL_COMPONENT_PROPS } from './constants/landing-options-modal.constants';
// Hooks
import CancelDropModalHook from 'components/cancel-drop-modal/hooks/cancel-drop-modal.hook';
// Types
import { LandingOptionsModalComponentType } from './types/landing-options-modal.component.type';

const LandingOptionsModalComponent = <T,>({
  modalConfiguration: { features, children, ...restFooter },
  onClose,
  showMethodModal,
  selectedMethod,
}: LandingOptionsModalComponentType<T>): React.JSX.Element | null => {
  const { maxWidth } = CancelDropModalHook();

  return showMethodModal ? (
    <ModalContainerComponent
      {...{ ...LANDING_OPTIONS_MODAL_COMPONENT_PROPS, maxWidth }}
      actions={<LandingOptionsModalCloseComponent<T> {...{ onClose }} />}
      content={
        <LandingOptionsModalFeaturesComponent<T> {...{ children, features, selectedMethod }} />
      }
      footer={<LandingOptionsModalFooterComponent<T> {...{ ...restFooter, selectedMethod }} />}
      header={<LandingOptionsModalTitleComponent<T> {...{ selectedMethod }} />}
    />
  ) : null;
};

export { LandingOptionsModalComponent };
